import { useState, useMemo, useEffect } from "react";
import { Page } from "@boundary/layouts/pageLayout";
import { useOrders } from "@boundary/_hooks";
import { HistoryItem } from "@boundary/components/historyItem";
import { HistoryTabs } from "@boundary/components/historyTabs";
import { useDebugEmulations } from "@boundary/components/debugWidget";
import type { OrderHistoryListItem } from "@domain/dtos/models/order.models";
import styles from "./history.module.scss";

const DEBUG_OPTIONS = [
  { key: "noOrders", label: "Нет заказов" },
  { key: "mockOrders", label: "Mock заказы" },
] as const;

const MOCK_COMPLETED_ORDERS: OrderHistoryListItem[] = [
  { order_number: "13424", status: "completed", status_description: "Выполнен", time_to_ready: null },
  { order_number: "13389", status: "completed", status_description: "Выполнен", time_to_ready: null },
  { order_number: "13201", status: "completed", status_description: "Выполнен", time_to_ready: null },
];

const MOCK_ACTIVE_ORDERS: OrderHistoryListItem[] = [
  { order_number: "13502", status: "printing", status_description: "Готовится", time_to_ready: "21:40" },
  { order_number: "13498", status: "printing", status_description: "Готовится", time_to_ready: "21:55" },
  { order_number: "13495", status: "printing", status_description: "Готовится", time_to_ready: "22:10" },
];

export function HistoryPage() {
  const { orderHistory, activeOrders } = useOrders();
  const [showActiveTab, setShowActiveTab] = useState(false);
  const debug = useDebugEmulations(DEBUG_OPTIONS);

  // Данные загружаются через prefetchRoute, не нужно дублировать запрос

  const displayedOrders = useMemo(() => {
    // Debug: нет заказов
    if (debug.noOrders) {
      return [];
    }

    // Debug: mock заказы
    if (debug.mockOrders) {
      return showActiveTab ? MOCK_ACTIVE_ORDERS : MOCK_COMPLETED_ORDERS;
    }

    // Real data
    if (showActiveTab) {
      return activeOrders;
    }
    return orderHistory.filter((order) => !activeOrders.includes(order));
  }, [showActiveTab, orderHistory, activeOrders, debug.noOrders, debug.mockOrders]);

  return (
    <Page screenBackground="sub" withFog>
      <Page.SafeArea />
      <Page.DisplayZone>
        <Page.DisplayZone.Header back center={<h1 className={styles.headerTitle}>Мои заказы</h1>} />
        <Page.DisplayZone.Body className={styles.content}>
          <HistoryTabs showActiveTab={showActiveTab} onTabChange={setShowActiveTab} />
          {displayedOrders.length === 0 ? (
            <div className={styles.emptyState}>
              <p>Нет заказов</p>
            </div>
          ) : (
            <ul className={styles.ordersList}>
              {displayedOrders.map((order) => (
                <HistoryItem key={order.order_number} item={order} isActive={showActiveTab} />
              ))}
            </ul>
          )}
        </Page.DisplayZone.Body>
      </Page.DisplayZone>
    </Page>
  );
}
